import React from 'react';
import FilterEditorStep from './FilterEditorStep';
import ModalHeader from 'components/ModalHeader';
import ModalHeaderWithClose from 'components/ModalHeaderWithClose';
import Modal from 'components/Modal';
import ColumnSelect from './ColumnSelect';
import orderBy from 'lodash/orderBy';
import {FormattedMessage} from 'react-intl';
import {selectDataSourceById} from 'state/dataSource/dataSourceSelectors';
import {connect} from 'react-redux';
import ButtonUnstyled from 'components/ButtonUnstyled';

let ColumnStepTitle = ({dataSource, column}) => {
  if (!column) {
    return (
      <FormattedMessage
        id="ColumnStep__EmptyTitle"
        description="Title of the Column filter step when no column has been selected"
        defaultMessage="Filter when"
      />
    );
  }

  if (dataSource) {
    return (
      <FormattedMessage
        id="ColumnStep__DataSourceTitle"
        description="Title of the Column filter step when single dataset has been selected"
        defaultMessage="In {dataSourceName}"
        values={{dataSourceName: dataSource.name}}
      />
    );
  }

  return (
    <FormattedMessage
      id="ColumnStep__AllDataSourcesTitle"
      description="Title of the Column filter step when all datasets have been selected"
      defaultMessage="All DataSets"
    />
  );
};

ColumnStepTitle = connect((state, {dataSourceId}) => ({
  dataSource: selectDataSourceById(state, dataSourceId),
}))(ColumnStepTitle);

class ColumnStep extends React.Component {
  state = {
    isOpen: false,
  };

  handleClick = () => {
    this.props.onClick();
    this.setState({
      isOpen: true,
    });
  };

  handleSelect = (column, dataSourceId, filterType) => {
    this.props.onSelect(column, dataSourceId, filterType);
    this.setState({
      isOpen: false,
    });
  };

  handleRequestModalClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const {selected, column, columns, dataSourceId} = this.props;

    return (
      <React.Fragment>
        <FilterEditorStep selected={selected} onClick={this.handleClick}>
          <ButtonUnstyled className={'FilterEditor__TitleButton'}>
            <div className="FilterEditor__StepTitle">
              <ColumnStepTitle column={column} dataSourceId={dataSourceId} />
            </div>
            <div className="FilterEditor__StepValue">
              {column && column.name}
            </div>
          </ButtonUnstyled>
        </FilterEditorStep>
        <Modal isOpen={this.state.isOpen}>
          <ModalHeaderWithClose onClose={this.handleRequestModalClose}>
            <ModalHeader>
              <FormattedMessage
                id="ColumnStep__ModalHeader"
                description="Header of modal when selecting a column to filter"
                defaultMessage="Select a Column"
              />
            </ModalHeader>
          </ModalHeaderWithClose>
          <ColumnSelect
            columns={orderBy(columns, 'name')}
            onSelect={this.handleSelect}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default ColumnStep;
